import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { activeOrganization$ } from "~/stores/organizations";

/**
 * Parent route for the post-datasource catalog progress step. Owns the
 * shared `beforeLoad` gate so both the param child (`$datasourceId`) and
 * the resume fallback (`index`) inherit it.
 *
 * Accepts both `"datasource"` and `"catalog"` so navigations from
 * `/onboard/datasource` after a successful `datasources.create` aren't
 * bounced during the brief window before `setOrgOnboardingStep("catalog")`
 * resolves. The catalog step is pre-payment in the new flow -- users see
 * their catalog being built before being asked to pay.
 */
export const Route = createFileRoute("/onboard/catalog")({
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "done") {
      throw redirect({ to: "/onboard", replace: true });
    }
    const org = activeOrganization$.get();
    if (!org?.id) {
      throw redirect({ to: "/onboard", replace: true });
    }
    if (org.onboarding !== "datasource" && org.onboarding !== "catalog") {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: () => <Outlet />,
});
